import { combineReducers } from '@reduxjs/toolkit';

import { surveyDesignerSlice } from '@highlight-cp/feature-survey-config/store';
import { highlighterApi } from '@highlight-cp/highlighter-api';
import { projectApi } from '@highlight-cp/project-api';
import { projectOrchestratorApi } from '@highlight-cp/project-orchestrator-api';
import { appTypeSlice, projectSlice, userSlice } from '@highlight-cp/redux-state';
import { resultsSlice } from '@highlight-cp/results/store';
import { surveyApi } from '@highlight-cp/survey-api';

const reducers = combineReducers({
  [projectApi.reducerPath]: projectApi.reducer,
  [projectOrchestratorApi.reducerPath]: projectOrchestratorApi.reducer,
  [highlighterApi.reducerPath]: highlighterApi.reducer,
  [surveyApi.reducerPath]: surveyApi.reducer,
  [surveyDesignerSlice.name]: surveyDesignerSlice.reducer,
  [projectSlice.name]: projectSlice.reducer,
  [appTypeSlice.name]: appTypeSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [resultsSlice.name]: resultsSlice.reducer,
});

export default reducers;
